export default "__VITE_ASSET__CwQUpalk__"